import { ArrowRight } from "lucide-react";
import { BrutalistBadge, SolidBlock } from "@/app/components/brand-scaffold";
import { Button } from "@/app/components/ui/button";

export function HomepagePathways() {
  return (
    <section className="px-4 py-16 sm:px-6 lg:px-8 lg:py-20">
      <div className="mx-auto max-w-5xl">
        <div className="mb-8">
          <BrutalistBadge bgClass="bg-[#F97316]" hoverBgClass="hover:bg-black" hoverTextClass="hover:text-white" className="text-white">
            GET STARTED
          </BrutalistBadge>
        </div>
        <h2 className="text-3xl sm:text-4xl lg:text-5xl font-black text-black mb-10">
          选择你的路径
        </h2>
        <div className="grid gap-6 lg:grid-cols-3">
          {pathways.map((p) => (
            <SolidBlock key={p.title} bgClass={p.bgClass} className="!p-6 flex flex-col">
              <h3 className={`text-xl font-black mb-3 ${p.textColor}`}>{p.title}</h3>
              <p className={`text-sm mb-6 flex-1 ${p.textColor} opacity-90`}>{p.desc}</p>
              <Button asChild variant="secondary" size="sm" className="gap-1 w-fit">
                <a href={p.href}>
                  {p.cta} <ArrowRight className="h-4 w-4" strokeWidth={3} />
                </a>
              </Button>
            </SolidBlock>
          ))}
        </div>
      </div>
    </section>
  );
}

const pathways = [
  {
    title: "我有一个能力",
    desc: "把本地 CLI、HTTP 服务、模型推理或专业工作流封装成 Hotline。先在本地跑通，再决定是否提交 review。",
    cta: "Responder Quick Start",
    href: "/docs/quick-start-responder",
    bgClass: "bg-[#F97316] text-white",
    textColor: "text-white",
  },
  {
    title: "我在做 Agent",
    desc: "让 Agent 通过 catalog 发现 Hotline，发起调用，并读取统一的 result_package。不用为每个外部能力写 client 逻辑。",
    cta: "Caller Quick Start",
    href: "/docs/quick-start-caller",
    bgClass: "bg-[#14B8A6] text-white",
    textColor: "text-white",
  },
  {
    title: "我想自托管",
    desc: "为团队或组织运行私有 catalog、review queue、relay 和 operator console。适合企业内部或研究复现。",
    cta: "Self-host Platform",
    href: "/docs/protocol-architecture",
    bgClass: "bg-[#FACC15] text-black",
    textColor: "text-black",
  },
];
